import $ from 'jquery';


const isJsonString = function (str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export function VerifyOTPCode(hotp, verificationUrl, completedUrl, errorUrl) {
    $.ajax({
        url: verificationUrl,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({ hotp: hotp }),
        success: function (response) {
            if (response && isJsonString(response)) {
                let resTxt = JSON.parse(response);

                if (resTxt && resTxt.ErrorMessage.length > 0) {
                    $("#opterrorMessageIncorrect").show();
                }
            } else {
                window.location.href = completedUrl;
            }
        },
        error: function (jqXHR) {
            if (jqXHR.status === 401) {
                $("#opterrorMessageFailed").show();
            }
        }
    });
}